import React from "react";

function Fail() {
  return (
    <div>
      Fail
      <br />
      <br />
      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aut expedita
      odit cupiditate voluptate nesciunt, asperiores ea tempore modi in repellat
      hic esse nobis amet libero? Ipsum quisquam cum tempore expedita nulla
      perferendis amet et!
    </div>
  );
}

export default Fail;
